<template>
  <div class="why-page">
    <HeroImage
      title="What is <br>ADHD?"
      subtitle="Treated or untreated ADHD symptoms<br>can interrupt the day’s demands."
      :image="heroImg"
      :image__sm="heroImgS"
    >
    </HeroImage>

    <WhyEachDay />
    <WhyDifficulties />

    <PageNav
      :menus="navItems"
      :bgClass="lightaccent"
      customClass="adhd-challenges-text"
    />

    <InfoBlockSticky />
    <InfoBlock class="trigger" />
    <Footer />
  </div>
</template>

<script>
import HeroImage from "../components/elements/HeroImage";
import heroImg from "../assets/images/3_25/why/hero@2x.webp";
import heroImgS from "../assets/images/3_25/why/hero_s@2x.webp";
import heroVideo from "../assets/videos/SoccerScene_FULL_v4.mp4";
import heromobileVideo from "../assets/videos/compressed/SoccerScene_1.mp4";
import InfoBlockSticky from "../components/sections/InfoBlockSticky";
import InfoBlock from "../components/sections/InfoBlock";
import Footer from "../components/sections/Footer";
import ogImage from "../assets/images/Jornay_OG_Image.jpg";

import PageNav from "../components/elements/PageNav.vue";
import WhyEachDay from "../components/sections/WhyEachDay.vue";
import WhyDifficulties from "../components/sections/WhyDifficulties.vue";

export default {
  name: "why-page",
  metaInfo: {
    title: "Explore ADHD Symptoms | JORNAY PM® (methylphenidate HCI)",
    link: [
      {
        rel: "canonical",
        href: "https://www.jornaypm.com/what-is-adhd",
      },
    ],
    meta: [
      {
        name: "description",
        content:
          "Explore the symptoms people living with ADHD may face. JORNAY PM® (methylphenidate HCI) is a medication for treating ADHD in patients 6 years and older. Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
      },
      {
        property: "og:title",
        content:
          "Explore ADHD Symptoms | JORNAY PM® (methylphenidate HCI)",
      },
      {
        property: "og:description",
        content:
          "Explore the symptoms people living with ADHD may face. JORNAY PM® (methylphenidate HCI) is a medication for treating ADHD in patients 6 years and older. Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
      },
      {
        property: "og:image",
        content: ogImage,
      },
      {
        property: 'google-site-verification',
        content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
      },
    ],
  },
  components: {
    HeroImage,
    InfoBlockSticky,
    InfoBlock,
    Footer,
    PageNav,
    WhyEachDay,
    WhyDifficulties,
  },
  data() {
    return {
      heroVideo,
      HeroImage,
      heroImg,
      heroImgS,
      heromobileVideo,
      navItems: [
        {
          title: "Interested in finding out more about a treatment option?",
          routerLinkName: "About",
          ctaText: "Learn more",
        },
      ],
      lightaccent: "lightaccent",
    };
  },
};
</script>

<style scoped></style>
